export default __webpack_public_path__ + "static/media/zeiss_logo.6a89edaf.svg";